<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <tabx @getactive="getactive"></tabx>
    <div class="paiming2">
      <p class="biaoti">
        本市办理建筑许可共15项，其中包含联办事项:企业投资项目备案、建设用地(含临时用地)规划许可证核发等15个环节; 较第一名上海多2个流程
      </p>
      <div v-if="active==0" class="paiming3">
        <div class="head">
          <div class="item1">环节个数(个）</div>
          <div class="item2">大连</div>
          <div class="item2">上海</div>
          <div class="item2">北京</div>
          <div class="item2">深圳</div>
        </div>
        <div class="body">
          <div class="bodyitem" v-for="(item,index) in list" :key="index">
            <div class="item1">{{ item.title }}</div>
            <div class="item2">{{ item.dl }}</div>
            <div class="item2">{{ item.sh }}</div>
            <div class="item2">{{ item.bj }}</div>
            <div class="item2">{{ item.sz }}</div>
          </div>
        </div>
      </div>
      <div v-if="active==1" class="paiming3">
        <div class="head">
          <div class="item1">耗时时长（天）</div>
          <div class="item2">大连</div>
          <div class="item2">上海</div>
          <div class="item2">北京</div>
          <div class="item2">深圳</div>
        </div>
        <div class="body">
          <div class="bodyitem" v-for="(item,index) in list2" :key="index">
            <div class="item1">{{ item.title }}</div>
            <div class="item2">{{ item.dl }}</div>
            <div class="item2">{{ item.sh }}</div>
            <div class="item2">{{ item.bj }}</div>
            <div class="item2">{{ item.sz }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tabx from "@/components/banlijianzhuxuke/tabx";

export default {
  name: "paiming",
  components: {tabx},
  data: function () {
    return {
      active: 0,
      list: [
        {
          title: '企业投资项目备案',
          dl: 9,
          sh: 6,
          bj: 10,
          sz: 10,
        }, {
          title: '建设用地(含临时用地)规划许可证核发',
          dl: 17,
          sh: 10,
          bj: 2,
          sz: 15,
        }, {
          title: '建设工程设计方案审查(含各类经济技术指标审查及批公示）',
          dl: 19,
          sh: 21,
          bj: 4,
          sz: 15,
        }, {
          title: '建设工程规划许可证核发',
          dl: 8,
          sh: 9,
          bj: 10,
          sz: 10,
        }, {
          title: '市政设施建设类审批',
          dl: 2,
          sh: 2,
          bj: 3,
          sz: 5,
        }, {
          title: '建筑工程施工许可证核发',
          dl: 5,
          sh: 2,
          bj: 4,
          sz: 3,
        }, {
          title: '城镇污水排入排水管网许可',
          dl: 8,
          sh: 9,
          bj: 10,
          sz: 10,
        }, {
          title: '规划条件核实',
          dl: 2,
          sh: 2,
          bj: 3,
          sz: 5,
        }, {
          title: '建设工程城建档案验收建',
          dl: 5,
          sh: 2,
          bj: 4,
          sz: 3,
        }, {
          title: '设工程消防备案',
          dl: 8,
          sh: 9,
          bj: 10,
          sz: 10,
        }, {
          title: '建设工程竣工验收备案',
          dl: 2,
          sh: 2,
          bj: 3,
          sz: 5,
        }, {
          title: '地名及地名标志设置',
          dl: 5,
          sh: 2,
          bj: 4,
          sz: 3,
        }, {
          title: '房屋所有权初始登记',
          dl: 8,
          sh: 9,
          bj: 10,
          sz: 10,
        }, {
          title: '用水报装(含受理签约)',
          dl: 2,
          sh: 2,
          bj: 3,
          sz: 5,
        }, {
          title: '五方验收',
          dl: 5,
          sh: 2,
          bj: 4,
          sz: 3,
        },],
      list2: [
        {
          title: '企业投资项目备案',
          dl: 9,
          sh: 6,
          bj: 10,
          sz: 10,
        }, {
          title: '建设用地(含临时用地)规划许可证核发',
          dl: 17,
          sh: 10,
          bj: 2,
          sz: 15,
        }, {
          title: '建设工程设计方案审查(含各类经济技术指标审查及批公示）',
          dl: 19,
          sh: 21,
          bj: 4,
          sz: 15,
        }, {
          title: '建设工程规划许可证核发',
          dl: 8,
          sh: 9,
          bj: 10,
          sz: 10,
        }, {
          title: '市政设施建设类审批',
          dl: 2,
          sh: 2,
          bj: 3,
          sz: 5,
        }, {
          title: '建筑工程施工许可证核发',
          dl: 5,
          sh: 2,
          bj: 4,
          sz: 3,
        }, {
          title: '城镇污水排入排水管网许可',
          dl: 8,
          sh: 9,
          bj: 10,
          sz: 10,
        }, {
          title: '规划条件核实',
          dl: 2,
          sh: 2,
          bj: 3,
          sz: 5,
        }, {
          title: '建设工程城建档案验收',
          dl: 5,
          sh: 2,
          bj: 4,
          sz: 3,
        }, {
          title: '建设工程消防备案',
          dl: 5,
          sh: 0,
          bj: 4,
          sz: 3,
        }, {
          title: '建设工程竣工验收备案',
          dl: 2,
          sh: 2,
          bj: 3,
          sz: 5,
        }, {
          title: '地名及地名标志设置',
          dl: 5,
          sh: 2,
          bj: 4,
          sz: 3,
        }, {
          title: '房屋所有权初始登记',
          dl: 8,
          sh: 9,
          bj: 10,
          sz: 10,
        }, {
          title: '用水报装(含受理签约)',
          dl: 2,
          sh: 2,
          bj: 3,
          sz: 5,
        },  {
          title: '五方验收',
          dl: 5,
          sh: 2,
          bj: 4,
          sz: 3,
        }, {
          title: '营商得分（分）',
          dl: 88,
          sh: 90,
          bj: 89,
          sz: 92,
        },],
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    getactive(e) {
      this.active = e;
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;

}

.paiming2 {
  width: 1323px;
  background: url("../../assets/kuangjialeft.png") left top no-repeat,
  url("../../assets/kuangjiabottom.png") right bottom no-repeat,
  rgba(35, 77, 205, 0.16);
  padding-top: 40px;
  height: 1085px;

  .head {
    width: 1276px;
    height: 60px;
    margin: auto;
    background: rgba(63, 75, 110, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 10%;
      @include flex_center_center();
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: bold;

      color: rgba(255, 255, 255, 1);
    }

    .item1 {
      width: 50%;
      @include flex_start_center();
      padding-left: 40px;

    }
  }
}

.body {
  margin: auto;
}

.bodyitem {
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;
  min-height: 52px;

  .item1, .item2, .item3 {
    width: 10%;
    @include flex_center_center();
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item1 {
    width: 50%;
    @include flex_start_center();
    padding: 10px 0 10px 40px;
    line-height: 32px;
  }
}
.bodyitem:hover{
  background: rgba(36, 105, 162, 1);
}

.biaoti {
  width: 1237px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin-left: 23px;
}

.paimingk {
  @include flex_start_start();
  margin-left: 23px;
  margin-top: 30px;
}

.paiming3 {
  width: 1276px;
  margin-left: 24px;
  margin-top: 34px;
}
</style>
